import { css } from '@emotion/react';
import { theme } from '@frontend/theme';
import { Heading, Table as DSTable, TableColumnConfig } from '@frontend/design-system';

type TableProps = {
  tableHeader: string;
  data: any[];
  colConfig: TableColumnConfig<any>[];
};

export const Table = ({ tableHeader, data, colConfig }: TableProps) => {
  if (!data || data.length === 0) {
    return null;
  }
  return (
    <div css={bodyStyles}>
      <Heading level={2} css={headerStyles}>
        {tableHeader}
      </Heading>
      <DSTable isPaginated={false} data={data} colConfig={colConfig} />
    </div>
  );
};
const headerStyles = css`
  padding: 2px 0 0 ${theme.spacing(2)};
  background-color: ${theme.colors.neutral5};
`;

const bodyStyles = css`
  padding: 0;
  div {
    .table {
      border-radius: 0 !important;
      border: none !important;
    }
  }
  [role='cell'] > span {
    white-space: pre-wrap;
    word-break: break-word;
  }
`;
